import React, { useState, useEffect } from 'react';

const SPLASH_DURATION = 2800; // ms before exit starts

const styles = `
@keyframes splashLogoIn{0%{opacity:0;transform:scale(.92)}100%{opacity:1;transform:scale(1)}}
@keyframes splashTextIn{0%{opacity:0;transform:translateY(8px)}100%{opacity:1;transform:translateY(0)}}
@keyframes splashDotsIn{0%{opacity:0}100%{opacity:1}}
@keyframes splashDotBounce{0%,100%{transform:translateY(0);opacity:.3}50%{transform:translateY(-8px);opacity:1}}
@keyframes splashExit{0%{opacity:1;transform:scale(1)}100%{opacity:0;transform:scale(.95)}}
@keyframes splashBgExit{0%{opacity:1}100%{opacity:0}}
`;

const SplashScreen = ({ onFinished }) => {
  const [exiting, setExiting] = useState(false);
  const [gone, setGone] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setExiting(true), SPLASH_DURATION);
    const t2 = setTimeout(() => { setGone(true); onFinished?.(); }, SPLASH_DURATION + 550);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [onFinished]);

  if (gone) return null;

  return (
    <>
      <style>{styles}</style>
      <div style={{
        position: 'fixed', inset: 0, zIndex: 99999, display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: '#050505',
        animation: exiting ? 'splashBgExit .5s cubic-bezier(.4,0,.2,1) .05s forwards' : 'none',
      }}>
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          animation: exiting ? 'splashExit .45s cubic-bezier(.4,0,.2,1) forwards' : 'none',
        }}>
          {/* Logo */}
          <img
            src="/logo.png" alt="Outsourced"
            style={{
              width: 68, height: 68, borderRadius: 18, objectFit: 'contain',
              opacity: 0, animation: 'splashLogoIn .9s cubic-bezier(.16,1,.3,1) .3s forwards',
              filter: 'drop-shadow(0 0 30px rgba(46,232,197,.2))',
            }}
          />

          {/* Text */}
          <div style={{
            marginTop: '1.25rem', fontSize: '1rem', fontWeight: 800,
            letterSpacing: '.12em', textTransform: 'uppercase',
            opacity: 0, animation: 'splashTextIn .7s cubic-bezier(.16,1,.3,1) .8s forwards',
            background: 'linear-gradient(135deg, #e8e8ec 30%, #2ee8c5)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
          }}>
            Outsourced
          </div>

          {/* Dots */}
          <div style={{
            display: 'flex', gap: 6, marginTop: '1.25rem',
            opacity: 0, animation: 'splashDotsIn .4s ease 1.2s forwards',
          }}>
            {[0, 1, 2].map(i => (
              <div key={i} style={{
                width: 5, height: 5, borderRadius: '50%', background: '#2ee8c5',
                animation: `splashDotBounce 1.2s ease-in-out ${i * 0.15}s infinite`,
              }} />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default SplashScreen;
